import React from 'react';
import Layout from '../components/layout';

// eslint-disable-next-line no-unused-vars
export default function Pricing({ csrfToken }) {
  return (
    <Layout>
      <p> Free 99! </p>
      <p> But feel free to cash app if you like https://cash.app/$williscoolcash </p>
    </Layout>
  );
}